import { MAP_PROVIDERS } from 'Src/location-v9/Location/constants';
import { getMapContainerCorners as getAwsMapsContainerCorners } from '@kyruus/aws-map';
import { getMapContainerCorners as getGoogleMapsContainerCorners } from '@kyruus/gmap';

export function getMapContainerBoundingBox(mapProvider, map) {
  /**
   * Normalizes longitude to [-180, 180] for BACKEND/DATABASE queries.
   * This is the ONLY time normalization should occur if range continuity is needed.
   * @param {number} lng - The current (potentially > 180 or < -180) longitude.
   * @returns {number} The geographically valid longitude.
   */
  const normalizeGeographicLongitude = (lng) => {
    // Uses the formula: ((L + 180) mod 360) - 180
    let normalized = (lng + 180) % 360;

    if (normalized < 0) {
      normalized += 360;
    }

    return normalized - 180;
  };

  const corners =
    mapProvider === MAP_PROVIDERS.AWS
      ? getAwsMapsContainerCorners(map.current)
      : getGoogleMapsContainerCorners(map.current);

  const normalizedTopLeftLng =
    mapProvider === MAP_PROVIDERS.AWS
      ? normalizeGeographicLongitude(corners.topLeft.lng)
      : corners.topLeft.lng;
  const normalizedBottomRightLng =
    mapProvider === MAP_PROVIDERS.AWS
      ? normalizeGeographicLongitude(corners.bottomRight.lng)
      : corners.bottomRight.lng;

  return `${corners.topLeft.lat},${normalizedTopLeftLng};${corners.bottomRight.lat},${normalizedBottomRightLng}`;
}

export function getMapCenter(mapProvider, map) {
  if (mapProvider === MAP_PROVIDERS.GOOGLE) {
    const center = map.current.getCenter();
    return { lat: center.lat(), lng: center.lng() };
  }

  return map.current.getCenter();
}
